import React from 'react';
import PropTypes from 'prop-types';

import './index.css';

const BurgerButton = ({ onClick }) => (
  <div className="burger-button">
    <span className="burger-bar" />
    <span className="burger-bar --middle" />
    <span className="burger-bar --bottom" />
    <button className="burger-button__button" onClick={onClick}>
      Open Menu
    </button>
  </div>
);

BurgerButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default BurgerButton;



// WEBPACK FOOTER //
// ./src/common/components/BurgerButton/index.js